import styled from 'styled-components';

export const SiteFooter = styled.div`
    padding: 30px;
    background: #f9f9f9;
    text-align: center;
`;